import  {useEffect, useState} from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import { useRouter } from "next/router";
import * as config from '../../../next.config.js'
import Image from 'next/image'
function Specialty({ entityId ,majors}) {
    const { locale } = useRouter();
    const { t } = useTranslation("common")
    const [fullMajors, setFullMajors] = useState("")
   useEffect(() => {
    if (entityId) {
        let tempData = JSON.parse(majors)
        tempData = tempData.sort((a, b) => (b.priority - a.priority))
        tempData = tempData.map(majorItem => {
            majorItem["titles"] = majorItem["titles"].filter(title => title.language.code == locale)
            majorItem["major"] = majorItem["major"].filter(major => major.language.code == locale)
            majorItem["subMajor"] = majorItem["subMajor"].filter(subMajor => subMajor.language.code == locale)

            return majorItem
        })
        let tempTitleListIds = Array.from(new Set(tempData.map(item => item.titleId)))
     
        let fullMajors = ""
       let fullMajorsforseo =" "
        for (let i = 0; i < tempTitleListIds.length; i++) {
            fullMajors += `<div class=${style.paragraphandIconsSpecialty} style="margin-bottom:0.5rem">`
          
            fullMajors += `<span><div class=${style.Circle}  ></div></span>`
            fullMajors += `<div class=${style.aboutText}> <ul style="list-style: none " class=${style.liStyle}>`
            if( tempData.filter(item => item.titleId == tempTitleListIds[i])[0].titles.length>0){
                fullMajorsforseo+= tempData.filter(item => item.titleId == tempTitleListIds[i])[0].titles[0].name.toString() +" "
                fullMajors += "<li >" + tempData.filter(item => item.titleId == tempTitleListIds[i])[0].titles[0].name.toString()
            }
          
            let tempMajorListIds = tempData.filter(item => item.titleId == tempTitleListIds[i]).map(item => item.major.length>0&&item.major[0].id)
            tempMajorListIds = Array.from(new Set(tempMajorListIds))
            fullMajors += `<ul style="list-style: none" class=${style.liStyle} >`
            for (let j = 0; j < tempMajorListIds.length; j++) {
                fullMajorsforseo+=tempData.find(item => item.titleId == tempTitleListIds[i] &&item.major.length>0&& item.major[0].id == tempMajorListIds[j])&&tempData.find(item => item.titleId == tempTitleListIds[i] &&item.major.length>0&& item.major[0].id == tempMajorListIds[j]).major[0].name.toString() + " "
                fullMajors += `<li style="margin-bottom:0.5rem">` + `<div class=${style.flexli}><div class=${style.Circle} style="margin:0"  ></div>` +(tempData.find(item => item.titleId == tempTitleListIds[i]&& item.major.length>0 && item.major[0].id == tempMajorListIds[j])? tempData.find(item => item.titleId == tempTitleListIds[i]&& item.major.length>0 && item.major[0].id == tempMajorListIds[j]).major[0].name.toString():"")+'</div>'
                let tempSubMjrList = tempData.filter(item => item.titleId == tempTitleListIds[i] &&item.major.length>0&& item.major[0].id == tempMajorListIds[j]).map(item => item.subMajorId)
                tempSubMjrList = Array.from(new Set(tempSubMjrList))
                fullMajors += `<ul style="list-style: none">`
                fullMajorsforseo+= t("specialist")+"  ("
                for (let k = 0; k < tempSubMjrList.length; k++) {
                   
                    tempData.filter(item => item.titleId == tempTitleListIds[i]&& item.major.length>0&& item.major[0].id == tempMajorListIds[j] && item.subMajorId == tempSubMjrList[k]).forEach(item => {
                        fullMajorsforseo+=item.subMajor[0].name.toString()  
                   
                        tempSubMjrList.length >1 &&  k != tempSubMjrList.length - 1?  fullMajorsforseo+="-":""
                        fullMajors += `<li style='padding: 0 ${locale == "ar" ? "20px" : "0"} 0 ${locale == "ar" ? "0" : "20px"}'>` + `<div class=${style.flexli}><div class=${style.CircleLi} style="margin:5px 0 0 0 "  ></div><div class=${style.flexli}>` + item.subMajor[0].name.toString() + "</li>"
                        
                    })

                }
                fullMajorsforseo+=" )"
                fullMajors += "</ul></li>"
            }

            fullMajors += "</ul></li>"
            fullMajors += "</ul></div></div>"
        }
        setFullMajors(fullMajors)
        //fullMajorsSeoBack({fullMajorsforseo:fullMajorsforseo,subMajors:tempData})
}
    }, [entityId,locale])
    return (
        <>
            {
                fullMajors.length ?
                    <>
                        <div className={style.SectionContainer}>
                            <div className={style.allcard}>

                                <div className={style.TitleandIcons} >
                                    <div className={style.icontitle}> <Image  className={style.icontitle} src={`${config.basePath}/assest/Specialty.svg`} width={100} height={100} alt={"hakeem"}/></div>
                                    <div className={style.hLine9 + " " + style.paddingZero} >{t("Specialty")} </div>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: fullMajors }} />

                            </div>
                        </div>
                    </>
                    : ""
            }
        </>
    )
}

export default Specialty
